
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "step-3---retrieve-candidate-details"
    }}>{`Step 3 - Retrieve candidate details`}</h1>
    <p>{`Use the `}<a parentName="p" {...{
        "href": "https://developer.seek.com/schema/#/query/candidateProfile"
      }}>{`GraphQL `}<inlineCode parentName="a">{`candidateProfile`}</inlineCode>{` query`}</a>{` with the `}<inlineCode parentName="p">{`candidateId`}</inlineCode>{` from the `}<a parentName="p" {...{
        "href": "/use-cases/apply-with-seek/handle-authorization"
      }}>{`authorization flow`}</a>{`.
This will retrieve candidate profile data that can pre-fill your software’s application form.`}</p>
    <pre><code parentName="pre" {...{
        "5550": true,
        "className": "language-scoobie-merged-code",
        "metastring": "[{\"type\":\"code\",\"lang\":\"graphql\",\"meta\":\"lovato-ignore-runnable-graphql-operation\",\"value\":\"query ($id: String!) {\\n  candidateProfile(id: $id) {\\n    profileId {\\n      value\\n    }\\n    createDateTime\\n    candidate {\\n      person {\\n        name {\\n          given\\n          family\\n        }\\n        communication {\\n          phone {\\n            formattedNumber\\n          }\\n          email {\\n            address\\n          }\\n        }\\n      }\\n    }\\n    employment {\\n      organization {\\n        name\\n      }\\n      positionHistories {\\n        start\\n        end\\n        title\\n      }\\n    }\\n    education {\\n      institution {\\n        name\\n      }\\n      educationDegrees {\\n        name\\n        degreeGrantedStatus\\n        date\\n      }\\n      descriptions\\n    }\\n    certifications {\\n      name\\n      issued\\n      effectiveTimePeriod {\\n        validTo\\n      }\\n      issuingAuthority {\\n        name\\n      }\\n      descriptions\\n    }\\n    qualifications {\\n      competencyName\\n    }\\n    attachments {\\n      descriptions\\n      seekRoleCode\\n      url\\n    }\\n  }\\n}\",\"position\":{\"start\":{\"line\":6,\"column\":1,\"offset\":231},\"end\":{\"line\":71,\"column\":4,\"offset\":1239},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":null,\"value\":\"{\\n  \\\"id\\\": \\\"seekAnzPublicTest:candidateProfile:apply:5G5NaFDmy7UigvGy6aT6VT\\\"\\n}\",\"position\":{\"start\":{\"line\":73,\"column\":1,\"offset\":1241},\"end\":{\"line\":77,\"column\":4,\"offset\":1330},\"indent\":[1,1,1,1]}},{\"type\":\"code\",\"lang\":\"jsonc\",\"meta\":null,\"value\":\"{\\n  \\\"candidateProfile\\\": {\\n    \\\"profileId\\\": {\\n      \\\"value\\\": \\\"seekAnzPublicTest:candidateProfile:apply:5G5NaFDmy7UigvGy6aT6VT\\\"\\n    },\\n    \\\"createDateTime\\\": \\\"2019-09-03T13:50:23.223Z\\\",\\n    \\\"candidate\\\": {\\n      \\\"person\\\": {\\n        \\\"name\\\": {\\n          \\\"given\\\": \\\"Ella\\\",\\n          \\\"family\\\": \\\"Greenholt\\\"\\n        },\\n        \\\"communication\\\": {\\n          \\\"phone\\\": [\\n            {\\n              \\\"formattedNumber\\\": \\\"(02) 5550 5678\\\"\\n            }\\n          ],\\n          \\\"email\\\": [\\n            {\\n              \\\"address\\\": \\\"EllaG@gmail.com\\\"\\n            }\\n          ]\\n        }\\n      }\\n    },\\n    // `Career history` from the candidate’s SEEK ANZ profile\\n    \\\"employment\\\": [\\n      {\\n        \\\"organization\\\": {\\n          \\\"name\\\": \\\"Swift Inc\\\"\\n        },\\n        \\\"positionHistories\\\": [\\n          {\\n            \\\"start\\\": \\\"2015-05\\\",\\n            \\\"end\\\": \\\"2018-03\\\",\\n            \\\"title\\\": \\\"Customer Service Representative\\\"\\n          }\\n        ]\\n      },\\n      {\\n        \\\"organization\\\": {\\n          \\\"name\\\": \\\"Ledner Inc\\\"\\n        },\\n        \\\"positionHistories\\\": [\\n          {\\n            \\\"start\\\": \\\"2018-10\\\",\\n            \\\"end\\\": null,\\n            \\\"title\\\": \\\"Customer Service Manager\\\"\\n          }\\n        ]\\n      }\\n    ],\\n    // `Education` from the candidate’s SEEK ANZ profile\\n    \\\"education\\\": [\\n      {\\n        \\\"institution\\\": {\\n          \\\"name\\\": \\\"Adelaide Business School\\\"\\n        },\\n        \\\"educationDegrees\\\": [\\n          {\\n            \\\"name\\\": \\\"Bachelor of Business Administration\\\",\\n            \\\"degreeGrantedStatus\\\": \\\"Granted\\\",\\n            \\\"date\\\": \\\"2016-10\\\"\\n          }\\n        ],\\n        \\\"descriptions\\\": []\\n      },\\n      {\\n        \\\"institution\\\": {\\n          \\\"name\\\": \\\"University of New South Wales\\\"\\n        },\\n        \\\"educationDegrees\\\": [\\n          {\\n            \\\"name\\\": \\\"Masters of Business Administration\\\",\\n            \\\"degreeGrantedStatus\\\": \\\"Granted\\\",\\n            \\\"date\\\": \\\"2018-07\\\"\\n          }\\n        ],\\n        \\\"descriptions\\\": [\\\"3.8 GPA\\\"]\\n      }\\n    ],\\n    // `Licences & certifications` from the candidate’s SEEK ANZ profile\\n    \\\"certifications\\\": [\\n      {\\n        \\\"name\\\": \\\"SA Drivers Licence\\\",\\n        \\\"issued\\\": null,\\n        \\\"effectiveTimePeriod\\\": {\\n          \\\"validTo\\\": \\\"2021-07\\\"\\n        },\\n        \\\"issuingAuthority\\\": null,\\n        \\\"descriptions\\\": []\\n      },\\n      {\\n        \\\"name\\\": \\\"Criminal History Check\\\",\\n        \\\"issued\\\": \\\"2021-01\\\",\\n        \\\"effectiveTimePeriod\\\": {\\n          \\\"validTo\\\": \\\"2023-01\\\"\\n        },\\n        \\\"issuingAuthority\\\": null,\\n        \\\"descriptions\\\": []\\n      }\\n    ],\\n    // `Skills` from the candidate’s SEEK ANZ profile\\n    \\\"qualifications\\\": [\\n      {\\n        \\\"competencyName\\\": \\\"Team building\\\"\\n      },\\n      {\\n        \\\"competencyName\\\": \\\"Customer focus\\\"\\n      },\\n      {\\n        \\\"competencyName\\\": \\\"Stakeholder management\\\"\\n      }\\n    ],\\n    \\\"attachments\\\": [\\n      {\\n        \\\"descriptions\\\": [\\\"Candidate resume\\\"],\\n        \\\"seekRoleCode\\\": \\\"Resume\\\",\\n        \\\"url\\\": \\\"https://graphql.seek.com/anzPublicTest/applications/4QM5fWQbdekL9gPtPZrzex/attachments/7wS9uaWkwNrz4L5EUjNoBpVHCo61gaTSTdqiEeqxPVAk\\\"\\n      }\\n    ]\\n  }\\n}\",\"position\":{\"start\":{\"line\":79,\"column\":1,\"offset\":1332},\"end\":{\"line\":204,\"column\":4,\"offset\":4365},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}}]",
        "[{\"type\":\"code\",\"lang\":\"graphql\",\"meta\":\"lovato-ignore-runnable-graphql-operation\",\"value\":\"query": true,
        "($id:": true,
        "String!)": true,
        "{\\n": true,
        "": true,
        "candidateProfile(id:": true,
        "$id)": true,
        "profileId": true,
        "value\\n": true,
        "}\\n": true,
        "createDateTime\\n": true,
        "candidate": true,
        "person": true,
        "name": true,
        "given\\n": true,
        "family\\n": true,
        "communication": true,
        "phone": true,
        "formattedNumber\\n": true,
        "email": true,
        "address\\n": true,
        "employment": true,
        "organization": true,
        "name\\n": true,
        "positionHistories": true,
        "start\\n": true,
        "end\\n": true,
        "title\\n": true,
        "education": true,
        "institution": true,
        "educationDegrees": true,
        "degreeGrantedStatus\\n": true,
        "date\\n": true,
        "descriptions\\n": true,
        "certifications": true,
        "issued\\n": true,
        "effectiveTimePeriod": true,
        "validTo\\n": true,
        "issuingAuthority": true,
        "qualifications": true,
        "competencyName\\n": true,
        "attachments": true,
        "seekRoleCode\\n": true,
        "url\\n": true,
        "}\\n}\",\"position\":{\"start\":{\"line\":6,\"column\":1,\"offset\":231},\"end\":{\"line\":71,\"column\":4,\"offset\":1239},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":null,\"value\":\"{\\n": true,
        "\\\"id\\\":": true,
        "\\\"seekAnzPublicTest:candidateProfile:apply:5G5NaFDmy7UigvGy6aT6VT\\\"\\n}\",\"position\":{\"start\":{\"line\":73,\"column\":1,\"offset\":1241},\"end\":{\"line\":77,\"column\":4,\"offset\":1330},\"indent\":[1,1,1,1]}},{\"type\":\"code\",\"lang\":\"jsonc\",\"meta\":null,\"value\":\"{\\n": true,
        "\\\"candidateProfile\\\":": true,
        "\\\"profileId\\\":": true,
        "\\\"value\\\":": true,
        "\\\"seekAnzPublicTest:candidateProfile:apply:5G5NaFDmy7UigvGy6aT6VT\\\"\\n": true,
        "},\\n": true,
        "\\\"createDateTime\\\":": true,
        "\\\"2019-09-03T13:50:23.223Z\\\",\\n": true,
        "\\\"candidate\\\":": true,
        "\\\"person\\\":": true,
        "\\\"name\\\":": true,
        "\\\"given\\\":": true,
        "\\\"Ella\\\",\\n": true,
        "\\\"family\\\":": true,
        "\\\"Greenholt\\\"\\n": true,
        "\\\"communication\\\":": true,
        "\\\"phone\\\":": true,
        "[\\n": true,
        "\\\"formattedNumber\\\":": true,
        "\\\"(02)": true,
        "5678\\\"\\n": true,
        "],\\n": true,
        "\\\"email\\\":": true,
        "\\\"address\\\":": true,
        "\\\"EllaG@gmail.com\\\"\\n": true,
        "]\\n": true,
        "//": true,
        "`Career": true,
        "history`": true,
        "from": true,
        "the": true,
        "candidate’s": true,
        "SEEK": true,
        "ANZ": true,
        "profile\\n": true,
        "\\\"employment\\\":": true,
        "\\\"organization\\\":": true,
        "\\\"Swift": true,
        "Inc\\\"\\n": true,
        "\\\"positionHistories\\\":": true,
        "\\\"start\\\":": true,
        "\\\"2015-05\\\",\\n": true,
        "\\\"end\\\":": true,
        "\\\"2018-03\\\",\\n": true,
        "\\\"title\\\":": true,
        "\\\"Customer": true,
        "Service": true,
        "Representative\\\"\\n": true,
        "\\\"Ledner": true,
        "\\\"2018-10\\\",\\n": true,
        "null,\\n": true,
        "Manager\\\"\\n": true,
        "`Education`": true,
        "\\\"education\\\":": true,
        "\\\"institution\\\":": true,
        "\\\"Adelaide": true,
        "Business": true,
        "School\\\"\\n": true,
        "\\\"educationDegrees\\\":": true,
        "\\\"Bachelor": true,
        "of": true,
        "Administration\\\",\\n": true,
        "\\\"degreeGrantedStatus\\\":": true,
        "\\\"Granted\\\",\\n": true,
        "\\\"date\\\":": true,
        "\\\"2016-10\\\"\\n": true,
        "\\\"descriptions\\\":": true,
        "[]\\n": true,
        "\\\"University": true,
        "New": true,
        "South": true,
        "Wales\\\"\\n": true,
        "\\\"Masters": true,
        "\\\"2018-07\\\"\\n": true,
        "[\\\"3.8": true,
        "GPA\\\"]\\n": true,
        "`Licences": true,
        "&": true,
        "certifications`": true,
        "\\\"certifications\\\":": true,
        "\\\"SA": true,
        "Drivers": true,
        "Licence\\\",\\n": true,
        "\\\"issued\\\":": true,
        "\\\"effectiveTimePeriod\\\":": true,
        "\\\"validTo\\\":": true,
        "\\\"2021-07\\\"\\n": true,
        "\\\"issuingAuthority\\\":": true,
        "\\\"Criminal": true,
        "History": true,
        "Check\\\",\\n": true,
        "\\\"2021-01\\\",\\n": true,
        "\\\"2023-01\\\"\\n": true,
        "`Skills`": true,
        "\\\"qualifications\\\":": true,
        "\\\"competencyName\\\":": true,
        "\\\"Team": true,
        "building\\\"\\n": true,
        "focus\\\"\\n": true,
        "\\\"Stakeholder": true,
        "management\\\"\\n": true,
        "\\\"attachments\\\":": true,
        "[\\\"Candidate": true,
        "resume\\\"],\\n": true,
        "\\\"seekRoleCode\\\":": true,
        "\\\"Resume\\\",\\n": true,
        "\\\"url\\\":": true,
        "\\\"https://graphql.seek.com/anzPublicTest/applications/4QM5fWQbdekL9gPtPZrzex/attachments/7wS9uaWkwNrz4L5EUjNoBpVHCo61gaTSTdqiEeqxPVAk\\\"\\n": true,
        "}\\n}\",\"position\":{\"start\":{\"line\":79,\"column\":1,\"offset\":1332},\"end\":{\"line\":204,\"column\":4,\"offset\":4365},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}}]": true
      }}>{`query ($id: String!) {
  candidateProfile(id: $id) {
    profileId {
      value
    }
    createDateTime
    candidate {
      person {
        name {
          given
          family
        }
        communication {
          phone {
            formattedNumber
          }
          email {
            address
          }
        }
      }
    }
    employment {
      organization {
        name
      }
      positionHistories {
        start
        end
        title
      }
    }
    education {
      institution {
        name
      }
      educationDegrees {
        name
        degreeGrantedStatus
        date
      }
      descriptions
    }
    certifications {
      name
      issued
      effectiveTimePeriod {
        validTo
      }
      issuingAuthority {
        name
      }
      descriptions
    }
    qualifications {
      competencyName
    }
    attachments {
      descriptions
      seekRoleCode
      url
    }
  }
}
`}</code></pre>
    <p>{`Please note that the `}<a parentName="p" {...{
        "href": "https://developer.seek.com/schema/#/query/candidateProfile"
      }}><inlineCode parentName="a">{`candidateprofile`}</inlineCode>{` query`}</a>{` can only be called with the `}<inlineCode parentName="p">{`candidateId`}</inlineCode>{` once per authorization, subsequent calls will return a `}<a parentName="p" {...{
        "href": "/graphql/error-responses#forbidden"
      }}>{`FORBIDDEN response`}</a>{`.
If your system needs to retrieve the candidate details again, for example where a candidate is applying for an additional job, your system will need to have the candidate repeat the authorization process.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;